var relatedproducts;
function enableslider() {
relatedproducts = new Swiper('.saunaslider', {
          
    centeredSlides: true,

      simulateTouch: true,
      preventClicks: true,  
      observer: true,
      loop: true,
      watchSlidesProgress: true,

navigation: {
nextEl: '.relatedswipenext',
prevEl: '.relatedswipeprev',
},
      
    
      
breakpoints: {
0: {
slidesPerView: 'auto',
spaceBetween: 30,
},

 1008: {
slidesPerView: 2,
spaceBetween: 30,
},

1241: {
slidesPerView: 3,
spaceBetween: 50,
}
}
    
    
    })
}

enableslider();

var allslides = $('.slidertemp').html();

    $('filteritem').click(function(){

        if(!$(this).hasClass('is-active')) {
    
        var filterby = $(this).data('filter');

        relatedproducts.removeAllSlides();	


            if (filterby == '') {
              relatedproducts.appendSlide(allslides);	
            }
              
            else {
           
          $(`.slidertemp [data-tags*="${filterby}"]`).each(function( index ) {
            $(this).clone().appendTo(".swiper-wrapper");
          });
              
        }
    
        $('filteritem').removeClass('is-active');
        $(this).addClass('is-active');
        relatedproducts.destroy(true, true);
        enableslider();
    }
    
    });